import React, { useState, useEffect } from "react";
import { Box, TextField, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import AddRole from "./AddRole";
import { get } from "../../../utils/api";

function EditRole(props) {
  const [fromValue, setFromValue] = useState({
    Date: "",
  });
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [facility, setFacility] = useState(["Tap to Select"]);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (facility.length < 6) {
      setFacility((prevFacility) => [
        ...prevFacility,
        `facility${prevFacility.length + 1}`,
      ]);
    }
  }, [facility]);

  useEffect(() => {
    console.log(props.index, "propsIndex");
    get(`/auth/getRoleById?Id=${props.index}`)
      .then((res) => {
        setFromValue({
          Date: res.data.data.createdAt.split("T")[0],
          name: res.data.data.name,
          moduleName: res.data.data.moduleName.map((item) => item).join(","),
          remark: res.data.data.remark,
          facilityName: res.data.data.facility?.facilityName,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [props.index]);

  const list = (anchor) => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "28rem",
        height: "100%",
        overflowY: "hidden",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      <AddRole value={isDrawerOpen} setValue={setIsDrawerOpen} index={index} />
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => props.setValues(false)}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{ p: 3, width: "100%", backgroundColor: "#fff", height: "100%" }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          Role Details
        </Typography>
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
            Date
          </Typography>

          <p>
            {new Date(fromValue.Date).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }) ?? ""}
          </p>
        </Box>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Name of Role
        </Typography>
        <p>{fromValue.name}</p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Facility
        </Typography>
        <p>{fromValue.facilityName ?? "-"}</p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Remark
        </Typography>
        <p>{fromValue.remark ? fromValue.remark : "-"}</p>
        <Box>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={props.handleEdit}
          >
            Edit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
        anchor="right"
        open={props.values}
        onClose={() => props.setValues(false)}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default EditRole;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
